import { useFranchise } from '~/shared/utils';
import { runtimeConfig } from '~/shared/utils/public-variables';

const { COMMERCE_URL } = runtimeConfig();

export const useReservationPaths = () => {
    const { franchiseAPIPath } = useFranchise();
    const reservationPath = `${COMMERCE_URL}/${franchiseAPIPath}/Reservation`;
    const add = `${reservationPath}/add`;

    return { add };
};
